module.exports = __webpack_public_path__ + "static/img/3.dbb694a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/kmR22/3.jpg
// module id = od+m
// module chunks = 1